import { PROGRESS_START, PROGRESS_FINISH, PROGRESS_FAIL } from "../../mutation-types";
import dashboardApi from "../../../api/dashboard";

const defaultState = () => ({
    mitra: [],
    dataPenjualan: [],
    dataPenjualanByYear: [],
    dataPendaftaranByYear: {},
    dataProduct: [],
    dataPenjualanByProduct: {},
    dataStockProduct: [],
    dataSortedStockProduct: [],
    dataPurchaseOrder: {
        dibuat: 0,
        dibayar: 0,
        diproses: 0,
        dikirim: 0,
        selesai: 0,
    },
});

const state = defaultState();

const getters = {
    chartData() {
        let month = [
            ['Jan'],
            ['Feb'],
            ['Mar'],
            ['Apr'],
            ['Mei'],
            ['Jun'],
            ['Jul'],
            ['Agus'],
            ['Sep'],
            ['Okt'],
            ['Nov'],
            ['Des'],
        ]

        let title_chart = [];

        for (var i = 0; i < month.length; i++) {

            for (var j = 0; j < Object.keys(state.dataPenjualanByYear).length; j++) {
                if (i == j) {

                    title_chart = ['Year'];
                    if (state.dataPenjualanByYear[j].product.length > 0) {
                        state.dataPenjualanByYear[j].product.forEach(element => {

                            month[i].push(parseInt(element.total_transaction))
                            title_chart.push(element.product_name + ' (' + element.product_code + ')');
                        });
                    }

                }
            }
        }

        month.unshift(title_chart);

        return month
    },
    chartDataProduct() {
        let month = [
            ['Jan'],
            ['Feb'],
            ['Mar'],
            ['Apr'],
            ['May'],
            ['Jun'],
            ['Jul'],
            ['Aug'],
            ['Sep'],
            ['Oct'],
            ['Nov'],
            ['Dec'],
        ]

        let title_chart = [];
        for (var i = 0; i < month.length; i++) {

            for (var j = 0; j < Object.keys(state.dataPenjualanByProduct).length; j++) {
                if (i == j) {
                    title_chart = ['Year', 'total_stock_in', 'total_stock_out']
                    state.dataPenjualanByProduct[j].product.forEach(element => {
                        month[i].push(parseInt(element.total_stock_in))
                        month[i].push(parseInt(element.total_stock_out))
                    });
                }
            }
        }
        month.unshift(title_chart);


        return month
    },
};

const mutations = {
    listMitra(state, data) {
        state.mitra = [];
        state.mitra = data;
    },
    listPenjualan(state, data) {
        state.dataPenjualan = [];
        state.dataPenjualan = data;
    },
    listPenjualanByYear(state, data) {
        state.dataPenjualanByYear = [];
        state.dataPenjualanByYear = data;
    },
    listPendaftaranByYear(state, data) {
        state.dataPendaftaranByYear = {};
        state.dataPendaftaranByYear = Object.assign({}, state.dataPendaftaranByYear, data);
    },
    listPenjualanByProduct(state, data) {
        state.dataPenjualanByProduct = {};
        state.dataPenjualanByProduct = Object.assign({}, state.dataPenjualanByProduct, data);
    },
    listProduct(state, data) {
        state.dataProduct = []
        state.dataProduct = data
    },
    listSummaryStockProduct(state, data) {
        state.dataStockProduct = [];
        state.dataSortedStockProduct = [];
        state.dataStockProduct = data;
        state.dataSortedStockProduct = [...state.dataStockProduct].sort((a,b) => b.stock_pos - a.stock_pos)
    },
    listPurchaseOrder(state, data) {
        state.dataPurchaseOrder.dibuat = data.dibuat 
        state.dataPurchaseOrder.dibayar = data.dibayar
        state.dataPurchaseOrder.diproses = data.diproses
        state.dataPurchaseOrder.dikirim = data.dikirim 
        state.dataPurchaseOrder.selesai = data.selesai 
    },

};
const actions = {
    getMitra({ commit }, params) {
        commit(PROGRESS_START, null, { root: true });
        dashboardApi.getMitraBaru(params).then(({ data: { data: { results } } }) => {
            if (results.length == 0) {
                commit("listMitra", 'error');
            } else {
                commit("listMitra", results);
            }
            commit(PROGRESS_FINISH, null, { root: true });
        }).catch(() => {
            commit("listMitra", 'error');
            commit(PROGRESS_FAIL, null, { root: true });
        });
    },
    getPenjualan({ commit }, params) {
        commit(PROGRESS_START, null, { root: true });
        dashboardApi.getSummaryPenjualan(params).then(({ data: { data } }) => {
            commit("listPenjualan", data);
            commit(PROGRESS_FINISH, null, { root: true });
        }).catch(() => {
            commit(PROGRESS_FAIL, null, { root: true });
        });
    },
    getPenjualanByYear({ commit }) {
        commit(PROGRESS_START, null, { root: true });
        dashboardApi.getSummaryPenjualanByYear().then(({ data: { data } }) => {
            if (data.length > 0) {
                commit("listPenjualanByYear", data);
            } else {
                commit("listPenjualanByYear", 'error');
            }
            commit("listProduct", data[0]['product']);
            commit(PROGRESS_FINISH, null, { root: true });
        }).catch(() => {
            commit("listPenjualanByYear", 'error');
            commit(PROGRESS_FAIL, null, { root: true });
        });
    },
    getdataByProduk({ commit }, val) {
        commit(PROGRESS_START, null, { root: true });
        dashboardApi.getSummaryPenjualanYearByProduk(val).then(({ data: { data } }) => {
            commit("listPenjualanByProduct", data);
            commit(PROGRESS_FINISH, null, { root: true });
        }).catch(() => {
            commit(PROGRESS_FAIL, null, { root: true });
        });
    },
    getSummaryStockProduct({ commit }) {
        commit(PROGRESS_START, null, { root: true });
        dashboardApi.getSummaryStockProduct().then(({ data: { data } }) => {
            if (data.results.length == 0) {
                commit("listSummaryStockProduct", 'error');
            } else {
                commit("listSummaryStockProduct", data.results);
            }
            commit(PROGRESS_FINISH, null, { root: true });
        }).catch(() => {
            commit("listSummaryStockProduct", 'error');
            commit(PROGRESS_FAIL, null, { root: true });
        });
    },
    getPurchaseOrder({ commit }) {
        commit(PROGRESS_START, null, { root: true });
        dashboardApi.getPurchaseOrder().then(({ data: { data } }) => {
            if (data.length == 0) {
                commit("listPurchaseOrder", 'error');
            } else {
                commit("listPurchaseOrder", data.results[0]);
            }
            commit(PROGRESS_FINISH, null, { root: true });
        }).catch(() => {
            commit("listPurchaseOrder", 'error');
            commit(PROGRESS_FAIL, null, { root: true });
        });
    }
};

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions,
};